import type { Game, UseGameStartOptions } from '@game/types'
import type { SeamlessWalletAccountDetailsResponse } from '@core/composables/data/seamless-wallet/useSeamlessWalletAccountDetails'
import { computed, useState, useNuxtData } from '#imports'

export const useBonusPlayCheck = () => {
    const isModalOpen = useState<boolean>('bonusPlay:modal-open', () => false)
    const pendingGameOptions = useState<UseGameStartOptions | null>('bonusPlay:pending-game-options', () => null)
    const { data: accountDetails } = useNuxtData<SeamlessWalletAccountDetailsResponse>('seamlessWallet:account_details')

    const hasBonusBalance = computed(() => Number(accountDetails.value?.wallets?.BONUS) > 0)

    function shouldShowBonusModal(game?: Game, isPlaygame?: boolean) {
        if (isPlaygame) return false
        if (!game) return false
        return hasBonusBalance.value && game.excluded_from_bonus_funds === true
    }

    function showModal(options: UseGameStartOptions) {
        pendingGameOptions.value = options
        isModalOpen.value = true
    }

    function closeModal() {
        isModalOpen.value = false
        pendingGameOptions.value = null
    }

    return {
        hasBonusBalance,
        shouldShowBonusModal,
        showModal,
        closeModal,
        isModalOpen,
        pendingGameOptions
    }
}
